import { isAnyOf, ListenerMiddlewareInstance } from "@reduxjs/toolkit";
import { language } from "@chef/constants";
import { showNotification } from "../features";
import { recipeApi } from "../features/recipe";

const intl = (
  {
    no: {
      ERROR: "Noe gikk galt, prøv igjen senere",
    },

    se: {
      ERROR: "Något gick fel, försök igen senare",
    },

    dk: {
      ERROR: "Noget gik galt, prøv igen senere",
    },
  } as const
)[language];

export default (listener: ListenerMiddlewareInstance) => {
  listener.startListening({
    matcher: isAnyOf(
      recipeApi.endpoints.addOrUpdateRating.matchFulfilled,
      recipeApi.endpoints.addOrUpdateRating.matchRejected,
    ),
    effect: async (action) => {
      if (action["meta"].requestStatus === "rejected") {
        showNotification({
          message: intl.ERROR,
          type: "error",
        });
      }
    },
  });
};
